import React from "react";
import { Box } from "@mui/material";
import { NFL_ALL_TIME_GREATS_STATS } from "../../constants/nflAllTimeGreats";

const NflGreatsStatRail = ({ stat, onStatChange }) => {
  const stats = Object.values(NFL_ALL_TIME_GREATS_STATS);

  return (
    <Box
      sx={{
        display: "flex",
        gap: 0.5,
        overflowX: "auto",
        pb: 0.5,
        mx: -0.5,
        px: 0.5,
        mb: 4,
      }}
    >
      {stats.map((option) => {
        const selected = option.key === stat;
        return (
          <Box
            key={option.key}
            component="button"
            type="button"
            onClick={() => onStatChange(option.key)}
            sx={{
              appearance: "none",
              border: 0,
              background: "transparent",
              color: selected ? "text.primary" : "text.secondary",
              fontWeight: selected ? 800 : 600,
              fontSize: "0.875rem",
              letterSpacing: "0.02em",
              px: 1.25,
              py: 0.75,
              cursor: "pointer",
              whiteSpace: "nowrap",
              borderBottom: "2px solid",
              borderColor: selected ? "text.primary" : "transparent",
              "&:hover": { color: "text.primary" },
            }}
          >
            {option.railLabel}
          </Box>
        );
      })}
    </Box>
  );
};

export default NflGreatsStatRail;
